import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/app/hellojob-pro/src/app/viec-lam/[id]/client.tsx");
